<template>
  <div>
    <label>{{ evt.created | datetime }}</label>
    <router-link :to="`/analyst?analyst_id=${evt.analyst.id}`"
       class="analyst-name blue-grey-text text-darken-4 strong small"
    >
      {{ evt.analyst.name }}
    </router-link>
    <span class="strong small"
          :class="{
            'teal-text text-lighten-1': evt.rating_transaction.transaction_type == 'Create',
            'pink-text text-lighten-1': evt.rating_transaction.transaction_type == 'Delete',
            'purple-text text-lighten-2': evt.rating_transaction.transaction_type == 'Confirm',
            'lime-text text-darken-1': evt.rating_transaction.transaction_type == 'Update' && evt.rating_transaction.to_points > evt.rating_transaction.from_points,
            'deep-orange-text text-lighten-2': evt.rating_transaction.transaction_type == 'Update' && evt.rating_transaction.from_points > evt.rating_transaction.to_points,
          }"
    >
      {{
        evt.rating_transaction.transaction_type == 'Create' ? 'added' :
        evt.rating_transaction.transaction_type == 'Delete' ? 'removed' :
        evt.rating_transaction.transaction_type == 'Confirm' ? 'confirmed' :
        evt.rating_transaction.transaction_type == 'Update' && evt.rating_transaction.to_points > evt.rating_transaction.from_points ? 'increased' :
        evt.rating_transaction.transaction_type == 'Update' && evt.rating_transaction.from_points > evt.rating_transaction.to_points ? 'decreased' :
        ''
      }}
    </span>
    <router-link :to="`/company?company_id=${evt.instrument.company_id}`"
       class="blue-grey-text text-darken-4 strong small"
    >
      {{ evt.instrument.symbol }} {{ evt.instrument.name | pretty }}
    </router-link>
    {{
      evt.rating_transaction.transaction_type == 'Create' ? 'to their portfolio' :
      evt.rating_transaction.transaction_type == 'Delete' ? 'from their portfolio' :
      evt.rating_transaction.transaction_type == 'Confirm' ? `for ${evt.rating_transaction.to_points} points` :
      evt.rating_transaction.transaction_type == 'Update' ? `from ${evt.rating_transaction.from_points} to ${evt.rating_transaction.to_points} points` :
      ''
    }}
  </div>
</template>

<script>
export default {
  name: 'EventRatingTransaction',
  props: {
    evt: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

div {
  border: 1px solid $tmf-gains;
  border-radius: 10px;
  padding: 5px;
  text-align: left;
  margin-bottom: 10px;
}

label {
  display: block;
}
</style>
